import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";

import PageWrapper from "components/PageWrapper";
import ReportStateProvider from "pages/report/state/Provider";
import MaterialsProvider from "features/firebase/materials/MaterialsProvider";

import FunctionSelectPage from "pages/report/pages/FunctionSelectPage";
import ItemsListPage from "pages/report/pages/ItemsListPage";
import ReportOverviewPage from "pages/report/pages/ReportOverviewPage";
import ReportUploadPage from "pages/report/pages/ReportUploadPage";

import {
  linkToReportFunctionSelect,
  linkToReportItemsList,
  linkToReportOverview,
  linkToReportUpload
} from "./links";

export default function ReportRoute() {
  const history = useHistory();
  const { t } = useTranslation();

  const navigationHandler = {
    handleBack: () => history.goBack(),
    confirm: true
  };

  return (
    <ReportStateProvider>
      <MaterialsProvider>
        <Switch>
          <Route exact path={linkToReportFunctionSelect()}>
            <PageWrapper
              label={t("report_function_select_label")}
              navigationHandler={navigationHandler}
            >
              <FunctionSelectPage />
            </PageWrapper>
          </Route>
          <Route path={linkToReportItemsList()}>
            <PageWrapper
              label={t("report_items_list_label")}
              navigationHandler={navigationHandler}
            >
              <ItemsListPage />
            </PageWrapper>
          </Route>
          <Route path={linkToReportOverview()}>
            <PageWrapper
              label={t("report_overview_label")}
              navigationHandler={navigationHandler}
            >
              <ReportOverviewPage />
            </PageWrapper>
          </Route>
          <Route path={linkToReportUpload()}>
            <PageWrapper
              label={t("report_upload_label")}
              navigationHandler={navigationHandler}
            >
              <ReportUploadPage />
            </PageWrapper>
          </Route>
          <Redirect to={linkToReportFunctionSelect()} />
        </Switch>
      </MaterialsProvider>
    </ReportStateProvider>
  );
}
